import { render } from "./HelpPdf.vue?vue&type=template&id=f256e0a0&scoped=true"
import script from "./HelpPdf.vue?vue&type=script&lang=js"
export * from "./HelpPdf.vue?vue&type=script&lang=js"

import "./HelpPdf.vue?vue&type=style&index=0&id=f256e0a0&lang=less&scoped=true"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f256e0a0"]])

export default __exports__